import { Outlet } from "react-router-dom";
import BackButton from "../../../components/BackButton";

export default function AdminAnalyticsHome() {
    return (
        <>
        <Outlet />
        </>
    );
}
